import type { TalkTranscript } from './types.js';

type Json = Record<string, any>;

/**
 * The transcript in a model event, if it carries one. Both transports see the
 * same Realtime events (the WebRTC data channel, or JSON frames on the Grok
 * and Live WebSocket), so both use this. Ported from line-ai's
 * useWebRtcDevice, which drives the /try captions.
 *
 * The agent's words stream as `delta`s on one `itemId` and settle with a
 * final `text`; the caller's line arrives once, when it is transcribed.
 */
export const toTranscript = (event: Json): TalkTranscript | null => {
  switch (event?.type) {
    case 'response.output_audio_transcript.delta':
    case 'response.audio_transcript.delta':
      return event.delta ? { role: 'agent', itemId: event.item_id, delta: event.delta } : null;
    case 'response.output_audio_transcript.done':
    case 'response.audio_transcript.done':
      return { role: 'agent', itemId: event.item_id, text: event.transcript ?? '', done: true };
    case 'conversation.item.input_audio_transcription.completed':
      return { role: 'caller', itemId: event.item_id, text: event.transcript ?? '', done: true };
    default:
      return null;
  }
};
